import { createContext } from 'react'

import type { IButtonProps } from '../types'

interface ButtonPropsProviderProps extends IButtonProps {
  children: React.ReactNode
}

export const ButtonContext = createContext({} as Omit<IButtonProps, 'children'>)
const { Provider } = ButtonContext

export function ButtonProvider({
  children,
  ...props
}: ButtonPropsProviderProps) {
  return <Provider value={props}>{children}</Provider>
}
